// extracted by mini-css-extract-plugin
export default {"ProductPage":"ProductPage__ProductPage___ltYre","menuContainer":"ProductPage__menuContainer___JhDFS","sectionHero":"ProductPage__sectionHero___Xs96J"};